import { Markdown } from "components/Markdown";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import styled from "styled-components";

const StyledDialog = styled(Dialog)`
  width: 50vw;
  max-width: 720px;

  @media (max-width: 720px) {
    width: 95vw;
  }

  .p-dialog-content {
    padding-top: 0;
  }
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px 0;
`;

interface ILegalDocumentDialogProps {
  visible: boolean;
  onClose: () => void;
  header: string;
  content?: string;
  isLoading?: boolean;
}

export function LegalDocumentDialog({
  visible,
  onClose,
  header,
  content,
  isLoading,
}: ILegalDocumentDialogProps) {
  return (
    <StyledDialog
      header={header}
      visible={visible}
      onHide={onClose}
      dismissableMask
    >
      {isLoading || !content ? (
        <SpinnerWrapper>
          <ProgressSpinner style={{ width: "32px", height: "32px" }} />
        </SpinnerWrapper>
      ) : (
        <Markdown>{content}</Markdown>
      )}
    </StyledDialog>
  );
}
